import { render, staticRenderFns } from "./transfer-add-or-update.vue?vue&type=template&id=2f998dd6&scoped=true"
import script from "./transfer-add-or-update.vue?vue&type=script&lang=js"
export * from "./transfer-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./transfer-add-or-update.vue?vue&type=style&index=0&id=2f998dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f998dd6",
  null
  
)

export default component.exports